/** Public beta — premium exports and pins are free; payment UI is hidden. */
export const APP_BETA = process.env.REACT_APP_BETA !== 'false';

export type AccountTier = 'free' | 'premium' | 'pro' | 'admin' | string | null | undefined;

export function hasEmperorTier(tier: AccountTier): boolean {
    if (APP_BETA) return true;
    return tier === 'premium' || tier === 'pro' || tier === 'admin';
}

export interface TimelapseExportLimits {
    maxFrames: number;
    maxWidth: number;
    watermark: boolean;
}

export function timelapseLimitsForTier(tier: AccountTier): TimelapseExportLimits {
    if (hasEmperorTier(tier)) {
        return { maxFrames: 24, maxWidth: 960, watermark: false };
    }
    return { maxFrames: 12, maxWidth: 640, watermark: true };
}
